<template>
  <div class="version2-bottom-right">
    <div class="version2-bottom-right-block">
      <Header :title="title2 || '申请人合作情况'"></Header>
      <Bar :options="appOptions" @echartClick="echartClick"></Bar>
    </div>
  </div>
</template>
<script>
import { getValueCooperate, agencyRange } from '@/api/databaseBin'
import Header from '../commonHeader/two.vue'
import BaseMixin from '@/views/_mixin'
import Bar from '@/components/echarts/Bar'
import { mapState } from 'vuex'

export default {
  mixins: [BaseMixin],
  data() {
    return {
      appOptions: {},
      relationChart: [],
      value: [],
      compName: []
    }
  },
  components: {
    Header,
    Bar
  },
  computed: {
    ...mapState('title', ['title2']),
    ...mapState('user', ['useNewGovTemplate'])
  },
  mounted() {
    this.initChart()
  },
  methods: {
    echartClick(params) {
      const name = params.name.split(':')
      if (params.componentType === 'radar') {
        if (this.useNewGovTemplate) {
          this.jumpIpi(`代理机构(精确)=(${name[0]}) and 专利类型=(发明授权 or 实用新型 or 外观设计)`)
        } else {
          this.jumpIpi(`申请人数量>(1) and 申请人=（${name[0]}）`, 'isMerge', 'publicOrder')
        }
      }
    },
    async initChart() {
      if (this.useNewGovTemplate) {
        await this.getAgencyRange()
      } else {
        await this.getValue()
      }
      this.appOptions = {
        textStyle: {
          fontSize: '14',
          color: '#F2F6FF'
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: (params) => {
            let text = this.name + '合作专利数' + '</br>'
            if (this.useNewGovTemplate) {
              text = ''
            }
            const color = ['#EF6896', '#6DC8EC', '#1E9493', '#5AD8A6', '#F6BD16']
            this.relationChart.forEach((item, i) => {
              text += `<div style="display: flex;align-items:center"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${color[i]}"></span>` + '<div style="flex:1;display: flex;justify-content:space-between;align-items:center">' +
                item.name + `<span style="font-weight: 800">${item.value}</span></div></div>` + '</br>'
            })
            return text
          }
        },
        radar: {
          triggerEvent: true,
          indicator: this.compName,
          radius: '50%',
          axisName: {
            show: true,
            padding: [0, -5, -10, -5],
            formatter: (a, indicator) => {
              console.log(indicator, 'indicator')
              // return indicator.text + ': \n' + indicator.value
              const params = indicator.text + ': ' + indicator.value
              let newParamsName = ''
              const paramsNameNumber = params.length
              const provideNumber = 9 // 一行显示几个字 然后就超过字数就会自动换行
              const rowNumber = Math.ceil(paramsNameNumber / provideNumber)
              if (paramsNameNumber > provideNumber) {
                for (let p = 0; p < rowNumber; p++) {
                  let tempStr = ''
                  const start = p * provideNumber
                  const end = start + provideNumber
                  if (p === rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber)
                  } else {
                    tempStr = params.substring(start, end) + '\n'
                  }
                  newParamsName += tempStr
                }
              } else {
                newParamsName = params
              }
              return newParamsName
            }
          },
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: ['#0AC8FF']
            }

          }
        },

        series: [
          {
            symbol: 'none', // 是否展示节点
            lineStyle: {
              width: 1
            },
            areaStyle: {
              color: 'rgba(255, 220, 56, 0.80)'
            },
            type: 'radar',
            data: [{
              value: this.value,
              name: this.name + '合作专利数'
            }],
            emphasis: {
              areaStyle: {
                color: '#68CAFE'
              }
            }
          }
        ]
      }
    },
    async getValue() {
      let query = {
        viewName: 'APPLICANT_COOPERATION_ANALYSIS',
        firstDim: 'COOPERATIVE_OBJ',
        querys: [
          {
            property: 'TOP_COOPERATIVE_PATENT_NUM',
            operation: 'LESS_EQUAL',
            value: '5'
          }
        ],
        measureFields: ['application_num']
      }
      if (this.isXZH) query = {}
      const data = await getValueCooperate(query)
      if (data[this.dataMapping]) {
        const { result: { relationChart } } = JSON.parse(data[this.dataMapping])
        this.opeTotal = relationChart.data[0].value
        this.name = relationChart.data[0].name
        const dataArr = []
        let max = 0
        relationChart.links.forEach(item => {
          item.name = item.target
          if (item.value > max) {
            max = item.value
          }
          dataArr.push({
            text: item.target,
            value: item.value
          })
          this.value.push(item.value)
        })
        dataArr.forEach(item => {
          this.compName.push({
            text: item.text,
            max: max + 20,
            textName: item.text,
            value: item.value
          })
        })
        console.log(this.compName, 'this.compName')
        this.relationChart = relationChart.links
      }
    },
    async getAgencyRange() {
      const res = await agencyRange()
      if (res.code === 200) {
        const dataArr = []
        let max = 0
        res.data.forEach(item => {
          item.value = item.count
          if (item.value > max) {
            max = item.value
          }
          dataArr.push({
            text: item.name,
            value: item.count
          })
          this.value.push(item.value)
        })
        dataArr.forEach(item => {
          this.compName.push({
            text: item.text,
            max: max + 20,
            value: item.value
          })
        })
        this.relationChart = res.data
      }
    }
  }
}
</script>
